
export const extractFirstLetters = (sentence) => {
  const words = sentence.split(" ").filter(word => word.length > 0);
  if (words.length < 2) {
    return words[0][0];
  }
  return words[0][0] + words[1][0];
}
